module.exports = __webpack_public_path__ + "media/assets/img/flags/ru-RU-24ae8eed8d133412572419a82b51e430.png";